import { IdCache } from './src/IdCache';
export { isShortLink } from './src/isShortLink';
export { isShortId } from './src/isShortId';
export { checkId } from './src/checkId';
export const idCache = new IdCache();
